import { addClass, removeClass } from "../config.js";

const isOpenClass = "is-open";
const accordionContentPadding = 48;

export const initializeAccordion = () => {
    const allAccordions = document.querySelectorAll(".js-accordion");
    allAccordions.forEach((accordion) => {
        const content = accordion.querySelector(".js-accordion-content");
        if (!content) return;

        accordion.addEventListener("click", function () {
            if (accordion.classList.contains("is-open")) {
                removeClass(accordion, isOpenClass);
                content.style.maxHeight = 0;
            } else {
                addClass(accordion, isOpenClass);
                content.style.maxHeight = content.scrollHeight + accordionContentPadding + "px";
            }
        });
    });
};
